import React from "react";
import { Route, Switch } from "react-router-dom";

import { ThemeProvider } from "@mui/material/styles";
import RSTheme from "../../../themes/RSTheme";

import Dashboard from "./Dashboard";
import Roster from "./Roster/Roster";
import RosterList from "./Roster/RosterList";

const RSRouter = () => (
    <ThemeProvider theme={RSTheme}>
        <Switch>
            <Route path="/rs/rosters/:id" component={Roster} />
            <Route path="/rs/rosters" component={RosterList} />
            <Route path="/rs/" component={Dashboard} />
        </Switch>
    </ThemeProvider>
);

export default RSRouter;
